export default class CanvasModel {
  constructor(learnerInfo, canvasUserId, isEnrollment, authProviderId) {
    if (isEnrollment === 'enrollment') {
      // API body for Canvas Course Enrollment
      this.enrollment = this.enrollmentInfo(learnerInfo, canvasUserId);
    } else {
      // API body for User Creation in Canvas
      this.user = this.userInfo(learnerInfo);
      this.pseudonym = this.pseudonymInfo(learnerInfo, authProviderId);
      this.communication_channel = this.communicationChannelInfo(learnerInfo);
      this.force_validations = false;
    }
  }

  userInfo(learnerInfo) {
    const fullName = learnerInfo._firstName + ' ' + learnerInfo._lastName;
    const preferredName = learnerInfo._preferredName || '';
    const sortableName = learnerInfo._lastName + ', ' + learnerInfo._firstName;
    return {
      name: fullName,
      short_name: preferredName,
      sortable_name: sortableName,
      skip_registration: true
    };
  }

  pseudonymInfo(learnerInfo, authProviderId = '147') {
    return {
      unique_id: learnerInfo._asuRite,
      sis_user_id: `edplusasu-${learnerInfo._asuRite}`,
      send_confirmation: false,
      authentication_provider_id: authProviderId
    };
  }

  communicationChannelInfo(learnerInfo) {
    return {
      type: 'email',
      address: learnerInfo._emailId
    };
  }

  enrollmentInfo(learnerInfo, canvasUserId) {
    return {
      user_id: learnerInfo._canvasUserId || canvasUserId,
      type: 'StudentEnrollment',
      enrollment_state: 'active',
      course_section_id: '',
      limit_privileges_to_course_section: false,
      notify: false
    };
  }
}
